// extracted by mini-css-extract-plugin
module.exports = {"flexInfo":"DisplayDefined_flexInfo__1D5PM"};